module.exports = __webpack_public_path__ + "assets/vertclinic.ru.ec79b034ce3aecdbf9c70471139c58aeb32a5dc7127c6ba806ed1679db0ee409.png";